
import SliderItem from './SliderItem.jsx'

export default function Slider({products, header, theme, filterParam}) {
    const deployContent =()=>{
        const filtered = products.filter((item)=>{
            return filterParam === "new" ? item.isNew : item.hasDis
        })
        return filtered.map((item, inx)=>{
            return <SliderItem key={`sliderItem_${header}_${inx}`} item={item} theme={theme} ribbonFlag={filterParam === "new" ? item.isNew : item.hasDis} ribbonText={filterParam === "new" ? "חדש!" : "במבצע!"}/>
        })
    }
    return (
        <div className="exampleHomePage_sliderComponent">
            <h4 className="exampleHomePage_subHeader" style={{textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`}}>{header}</h4>
            <div className="exampleHomePage_slider">
                <div style={{color:theme.accent_color, fontWeight:"bold", marginLeft:"6px", cursor:"pointer"}}>⟨</div>
                {deployContent()}
                <div style={{color:theme.accent_color, fontWeight:"bold", marginRight:"6px", cursor:"pointer"}}>⟩</div>
            </div>
        </div>
    )
}
